/**
 * Longitud del body de una plantilla contando solo el texto fijo y los valores tecleados:
 * los placeholders {{n}} sin llenar no suman. Conteo en unidades UTF-16 (String#length):
 * los emojis suman 2+, lado seguro frente al límite de Meta.
 */
export const getTemplateMessageLength = (templateText, valuesByToken = {}) => {
  const message = templateText.replace(
    /{{([^}]+)}}/g,
    (match, token) => valuesByToken[token] || ''
  );
  return message.length;
};
